import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MobileMenu from '../MobileMenu/MobileMenu';
import { totalPrice } from "../../utils";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import loginServices from '../../Service/login.service';
import './header.css';

const Header = (props) => {
    const [menuActive, setMenuState] = useState(false);
    const [cartActive, setcartState] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("user"));
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUserRole(parsedUser.user_role);
            } catch (e) {
                console.error("Failed to parse user data:", e);
            }
        }
    }, [isLoggedIn]);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const handleLogout = () => {
        loginServices.logOut();
        setIsLoggedIn(false);
        window.location.href = '/login';
    };

    const { carts } = props;

    return (
        <header id="header">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-md-6 col-6 d-lg-none dl-block">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                                        {/* <img src={props.Logo} alt="" /> */}
                                    </Link>
                                </div>
                            </div>
                        <div className="col-lg-7 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children"><Link onClick={ClickHandler} to="/home">Home</Link></li>
                                        <li><Link onClick={ClickHandler} to="/about">About</Link></li>
                                        <li className="menu-item-has-children"><Link onClick={ClickHandler} to="/services">Services</Link></li>
                                        <li className="menu-item-has-children"><Link onClick={ClickHandler} to="/shop">Shop</Link></li>
                                        <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="close-form">
                                        <Link onClick={ClickHandler} className="theme-btn" to="/orders/new">Order Now</Link>
                                    </div>
                                    <div className="close-form">
                                        {isLoggedIn ? (
                                            <>
                                                <button onClick={handleLogout} className='theme-btn py-2 px-5'>Logout</button>
                                                {userRole === 4 && (
                                                    <Link onClick={ClickHandler} className='theme-btn ms-2' to="/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e">Admin</Link>
                                                )}
                                            </>
                                        ) : (
                                            <Link onClick={ClickHandler} className='theme-btn' to="/login">Login</Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
};

const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};

export default connect(mapStateToProps, { removeFromCart })(Header);
